import AntList from 'antd/lib/list';

import 'antd/lib/list/style/index.css';

export default AntList;
